import { render, staticRenderFns } from "./PointCloudLoaderPanel.vue?vue&type=template&id=78681120&scoped=true"
import script from "./PointCloudLoaderPanel.vue?vue&type=script&lang=js"
export * from "./PointCloudLoaderPanel.vue?vue&type=script&lang=js"
import style0 from "./PointCloudLoaderPanel.vue?vue&type=style&index=0&id=78681120&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78681120",
  null
  
)

export default component.exports